// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","loader__insideThing":"Loader_loader__insideThing__LOiWP","loader__spinner__text":"Loader_loader__spinner__text__Gx2hf"};